import {useState, React, useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { useAuth, } from '../../../setup/AuthContext'
import { db, auth, app, storage } from '../../../setup/Firebase';
import { createCheckoutSession, getProducts, getStripePayments, getCurrentUserSubscription, get, getCurrentUserSubscriptions, createPortalLink} from "@invertase/firestore-stripe-payments";
import "./dashnavbar.css"
import { getStorage, ref, getDownloadURL } from 'firebase/storage'
import {getDoc, doc, getFirestore, collection } from 'firebase/firestore'


export default function DashNavbar() {

  const [error, setError] = useState("")
  const { logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    setError('')

    try {
      await logout()
        navigate('/client-login')
        
    } catch {
      setError('Failed to log out')
    }
  }
  const { resetPassword } = useAuth()

  const payments = getStripePayments(app, {
    productsCollection: "products",
    customersCollection: "customers",
  });

  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const checkSubscription = async () => {
    try {
      auth.currentUser.getIdToken(true)
      const session = await getCurrentUserSubscriptions(payments, {
        price: 'price_1Ox55FLUOgST0iEQH9VETIlg',
      });
      setIsSubscribed(session[0]?.status === 'active');
    } catch (error) {
      console.error('Error checking subscription:', error);
      // Handle error gracefully, e.g., display an error message to the user
    }
  };
  
  const checkAdmin = async () => {
    try {
      auth.currentUser.getIdToken(true)
      const docRef = doc(db, "admin", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      setIsAdmin(docSnap.exists());
    } catch (error) {
      console.log(error)
    }  
  }
  useEffect(() => {
    // Check subscription status initially
    checkSubscription();
    checkAdmin();
  }, []);

  return (
    <div className='emas__dashnavbar'>
      {/* <CheckSubscription /> */}
      <div className='emas__dashnavbar-top'>
        <div>
          <h1>Client Portal</h1>
        </div>
        <div className='emas__dashnavbar-top_signout'>
          <button onClick={handleLogout}>Sign Out</button>
        </div>
      </div>
      <div style={{ display: isSubscribed || isAdmin ? 'flex' : 'none'}} className='emas__dashnavbar-premium'>
        <div>
          <p>{isAdmin ? 'You are an admin.' : 'Premium Subscription is Active.'} <a href='https://billing.stripe.com/p/login/aEU4gP8YyaJZ6Lm6oo'>{isAdmin ? '': 'Cancel Subscription?'}</a></p>
        </div>
        <div className='emas__dashnavbar-premium_password'>
          {/* <a onClick={resetPassword(auth.currentUser.email)}>Forgot Password?</a> */}
        </div>
      </div>
      <div>
          {/* <p>Logged in as: {auth.currentUser.email}</p> */}
          {/* <p>Manage Subscription: </p> */}
      </div>
      {/* <div className='emas__dashnavbar-links'>
        <div>
          <button>General</button>
        </div>
        <div>
          <button>Data</button>
        </div>
        <div>
          <button>Model</button>
        </div>
        <div>
          <button>Settings</button>
        </div>
        <div>
          <button onClick={stuff}>Profile</button>
        </div>
      </div> */}
    </div>
  )
}

